import React, { PureComponent } from 'react';
import { Table, Icon, Button, message } from 'antd';
import services from '../../services/api';
import Modal from '../Modal/index';

export default function CommonList(columns, api) {
  return function(WrapperComponent) {
    return class extends PureComponent {
      constructor() {
        super();
      }
      componentDidMount() {}
      edit(record) {
        this.props.edit(record);
      }
      delete(record) {
        Modal.open({
          title: '提示',
          width: '300px',
          content: '确定要删除?',
          isOkBtn: true,
          isCancelBtn: true,
          ok: () => {
            services[api].delete({ id: record.id }).then(data => {
              if (data.code === 0) {
                message.success(data.msg);
                this.props.queryList();
                Modal.close();
              } else {
                message.error(data.msg);
              }
            });
          },
          cancel: () => {
            Modal.close();
          }
        });
      }
      render() {
        const newColumns = [
          ...columns,
          {
            title: '操作',
            key: 'action',
            width: '12%',
            render: record => {
              return (
                <div className="table-action">
                  <Button
                    type="primary"
                    size="small"
                    onClick={this.edit.bind(this, record)}
                  >
                    <Icon type="edit" />
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    disabled={record.children && record.children.length > 0}
                    onClick={this.delete.bind(this, record)}
                  >
                    <Icon type="delete" />
                  </Button>
                </div>
              );
            }
          }
        ];
        return (
          <div>
            {this.props.data ? (
              <Table
                columns={newColumns}
                dataSource={this.props.data}
                rowKey="id"
              />
            ) : (
              '暂无数据'
            )}
            <WrapperComponent {...this.props} />
          </div>
        );
      }
    };
  };
}
